'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.MuggleMixin = void 0;
var tslib_1 = require("tslib");
var vue_1 = tslib_1.__importDefault(require("vue"));
var vue_class_component_1 = tslib_1.__importDefault(require("vue-class-component"));
/**
 * Adds `muggle` computed property determining if component is wrapped with
 * web component wrapper (value is `false`) or not (value is `true`)
 */
var MuggleMixin = /** @class */ (function (_super) {
    tslib_1.__extends(MuggleMixin, _super);
    function MuggleMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MuggleMixin.prototype, "muggle", {
        get: function () {
            var shadowRoot = this.$root.$options.shadowRoot;
            return !shadowRoot || shadowRoot instanceof HTMLHeadElement;
        },
        enumerable: false,
        configurable: true
    });
    MuggleMixin = tslib_1.__decorate([
        vue_class_component_1.default
    ], MuggleMixin);
    return MuggleMixin;
}(vue_1.default));
exports.MuggleMixin = MuggleMixin;
